export const SET_BULK_OPERATION_STATUS = 'SET_BULK_OPERATION_STATUS';